export const LOGO_DARK_BG = "https://customer-assets.emergentagent.com/job_jci-content-platform/artifacts/mv5wtmf7_Asset%203.png";

export const NAV_ITEMS = [
  { label: "Home", path: "/" },
  {
    label: "About", children: [
      { label: "About JCI Bangladesh", path: "/page/about-jci-bangladesh" },
      { label: "National President's Corner", path: "/page/presidents-corner" },
      { label: "Creed, Mission & Vision", path: "/page/creed-mission-vision" },
      { label: "Motto 2026", path: "/page/motto-2026" },
      { label: "Organizational Structure", path: "/page/organizational-structure" },
    ]
  },
  {
    label: "Team", children: [
      { label: "National Governing Board", path: "/team/governing-board" },
      { label: "Local Presidents", path: "/team/local-presidents" },
      { label: "National Committees", path: "/committees" },
      { label: "National Skills Development Commission", path: "/team/skills-development" },
    ]
  },
  { label: "Local Organizations", path: "/local-organizations" },
  {
    label: "Activities", children: [
      {
        label: "Areas of Opportunity", children: [
          { label: "Individual Development", path: "/page/individual-development" },
          { label: "Community Impact", path: "/page/community-impact" },
          { label: "International Cooperation", path: "/page/international-cooperation" },
          { label: "Business & Entrepreneurship", path: "/page/business-entrepreneurship" },
        ]
      },
      {
        label: "Flagship Events", children: [
          { label: "Carnival", path: "/page/carnival" },
          { label: "Inauguration Ceremony", path: "/page/inauguration" },
          { label: "40 Under 40", path: "/page/40-under-40" },
          { label: "TOYP", path: "/page/toyp" },
          { label: "Women of Inspiration Award", path: "/page/women-of-inspiration" },
          { label: "Debate & Public Speaking", path: "/page/debate-championship" },
          { label: "JCI Bangladesh Academy", path: "/page/jci-academy" },
          { label: "National Convention (NATCON)", path: "/page/natcon" },
          { label: "ASPAC", path: "/page/aspac" },
          { label: "World Congress", path: "/page/world-congress" },
        ]
      },
      {
        label: "Calendar & Archives", children: [
          { label: "Activities Calendar", path: "/page/activities-calendar" },
          { label: "Past Activities Archive", path: "/page/past-activities" },
        ]
      },
    ]
  },
  {
    label: "Partners", children: [
      { label: "Strategic Partners", path: "/partners" },
      { label: "Corporate Sponsors", path: "/partners" },
    ]
  },
  {
    label: "Resources", children: [
      { label: "Downloads", path: "/page/downloads" },
      { label: "Brand Guidelines & Logo Kit", path: "/page/brand-guidelines" },
      { label: "Publications", path: "/page/publications" },
      { label: "News & Press Releases", path: "/news-press" },
      { label: "Media Gallery", path: "/media-gallery" },
      { label: "Content Hub", path: "/content-hub" },
    ]
  },
  {
    label: "Hall of Fame", children: [
      { label: "International Awards Showcase", path: "/page/awards-showcase" },
      { label: "Past National Presidents", path: "/team/past-presidents" },
      { label: "25 Years of Glory", path: "/page/25-years" },
    ]
  },
  { label: "Store", path: "/store" },
  { label: "Contact", path: "/contact" },
];
